import { AppStore } from "./stores/AppStore";

export const configureStore = () => {
  if (window.data_user) {

  }
  const store = AppStore.create({
    ...window.data,
    chapters: window.data.playlist,
    user: window.data_user,
    review: window.data.review.length > 0 ? window.data.review[0] : null,
  });

  return { store };
};
